import { signInWithCustomToken } from 'firebase/auth'
import { auth } from './firebase'

const PARAM = 'auth'

function takeToken() {
  const url = new URL(window.location.href)
  const token = url.searchParams.get(PARAM)
  if (!token) return null

  url.searchParams.delete(PARAM)
  window.history.replaceState(null, '', url)
  return token
}

export async function signInWithMagicToken() {
  try {
    const token = takeToken()
    if (!token) return

    await auth.authStateReady()
    if (!auth.currentUser) await signInWithCustomToken(auth, token)
  } catch (error) {
    console.error(error)
  }
}
